var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/modules/_has.js
// module id = ../../../../core-js/modules/_has.js
// module chunks = 4